import { logsSlice } from './../logs/store/logs.store';
import dashboardRoutes from './routes';
import groupStatisticsSlice from './store/statistics.store';

export { dashboardRoutes, groupStatisticsSlice };

const moduleConfig = {
  routes: dashboardRoutes,
  reducers: {
    groupStatistics: groupStatisticsSlice.reducer,
    logs: logsSlice.reducer,
  },
};

export default moduleConfig;
